module.exports = "\n<!-- <router-outlet name=\"sellersection\"></router-outlet> -->\n<!-- <p>\n  dashboard works!\n  <a (click)=\"auth.logout()\" href=\"/\">Log Out</a>\n</p> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dashboard/dashboard.component.html
// module id = ./src/app/shared/dashboard/dashboard.component.html
// module chunks = main